import React, { useState, useEffect } from "react";
import Sidebar from "../layouts/sidebar";
import WindowHead from "../layouts/windowHead";
import DataTable from "react-data-table-component";
import Loaders from "../../assets/loaders/loaders";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Col, InputGroup, Row, Form } from "react-bootstrap";
import { useRegisterHeaderMutation } from "../../services/post";


function HeaderRegist() {
    const [showNav, setShowNav] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [header, setHeader] = useState("");
    const [headerId, setHeaderId] = useState("");

    const [validated, setValidated] = useState(false);
    const [error1, setError1] = useState('');
    const [error2, setError2] = useState('');
    const [refreshTable, setRefreshTable] = useState(false);

    const handleHeader = (e) => {
        const headerRegx = /^[A-Z]*$/;
        if (headerRegx.test(e.target.value) === false) {
            setError1("Only Uppercase Letters allowed.")
        }
        else {
            setError1('');
        }
        setHeader(e.target.value);
    }
    const handleHeaderID = (e) => {
        const headerIdRegx = /^\d{1,19}$/;
        if (headerIdRegx.test(e.target.value) === false) {
            setError2("Only Numeric values allowed.");
        }
        else {
            setError2('');
        }
        setHeaderId(e.target.value);
    }

    const [register] = useRegisterHeaderMutation();
    const SubmitHeader = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            const headers = {
                header: header,
                header_id: headerId
            }
            try {
                const response = await register(headers);
                setIsLoading(true);
                if (response?.data?.statusCode === 200) {
                    setIsLoading(false);
                    toast.success(response?.data?.message || "Header Registered", { autoClose: 2000 });
                    setRefreshTable(true);
                    setHeader("");
                    setError1('');
                    setHeaderId("");
                    setError2('');
                    setValidated(true);
                } else {
                    setIsLoading(false);
                    toast.error(response?.error?.data?.message || response?.error?.data?.Error || "An error occurred");
                }
            } catch (error) {
                setIsLoading(false);
                toast.error(error?.message || "An error has occurred");
            }
        }
        setValidated(true);
    };

    const [totalRows, setTotalRows] = useState(0);
    // eslint-disable-next-line
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState([]);

    const columns = [
        {
            name: 'S. No.',
            selector: (_, index) => (currentPage - 1) * 20 + index + 1,
            width: '100px',
        },
        {
            name: 'Header ID',
            selector: (row) => row.header_id,
            width: '280px',
        },
        {
            name: 'Header',
            selector: (row) => row.header,
            width: '200px',
        },
        {
            name: "Created At",
            cell: (row) => (row.createdAt === "" || row.createdAt === null) ? "-" : formatTime(row.createdAt),
            width: "200px",
        },
        {
            name: 'Updated At',
            cell: (row) => (row.updatedAt === "" || row.updatedAt === null) ? "-" : formatTime(row.updatedAt),
            width: '200px',

        },
    ]

    // DATE FORMAT - DATA TABLE
    function formatTime(time) {
        // Create a new Date object from the provided time
        const date = new Date(time);
        // Format the date part (day and month)
        const datePart = date.toLocaleDateString("en-US", { day: 'numeric', month: 'short' });
        // Get the full year
        const yearPart = date.getFullYear();
        // Format the time part (hours and minutes, 24-hour format)
        const timePart = date.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
        // Combine and return the formatted date and time
        return `${datePart} ${yearPart}, ${timePart}`;
    }

    const handlePageChange = page => {
        setCurrentPage(page)
        fetchData(page);
    }
    const handlePerRowsChange = async (rowperpage, page) => {
        fetchData(page, "")
    };


    useEffect(() => {
        fetchData(1, "");
    }, [refreshTable])

    const fetchData = async (page) => {
        setIsLoading(true);
        fetch(`${process.env.REACT_APP_API_BASE_URL}/get_header_data?limit=20&pageNumber=${page}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${localStorage.getItem("tokenn")}`
                }
            }
        )
            .then((res) =>
                res.json()
            )
            .then(
                (result) => {
                    if (result.statusCode === 200) {
                        setIsLoading(false);
                        setItems(result.data.result.data);
                        setFilter(result.data.result.data);
                        setTotalRows(result.data.result.totalPosts);
                    } else {
                        setIsLoading(false);
                        toast.error(result?.message || 'Something went wrong!');
                    }
                },
                (error) => {
                    setIsLoading(false);
                    toast.error(error.message);
                }
            )
    }


    return (
        <>
            {isLoading && <Loaders />}
            <ToastContainer />

            <div className="bg-inner">
                <Sidebar show={showNav} onClose={() => setShowNav(false)} />
                <div className="d-flex flex-column ms-0 ms-xxl-3 col-12 col-sm-12 col-xxl-9">
                    <WindowHead sidebarOpen={() => setShowNav(!showNav)} />

                    <div className="main-content">
                    <div className="d-block">
                            <span className="mb-3">
                                <h4 className="m-0">Header Registrations</h4>
                                <p>Provide the below Details to create a New Header.</p>
                            </span>

                            <Form noValidate validated={validated} onSubmit={SubmitHeader}>
                                <Row className="mt-3">
                                    <Form.Group as={Col} md="5" controlId="validationCustom01" className="mb-4">
                                        <InputGroup hasValidation>
                                            <InputGroup.Text id="inputGroupPrepend">Header: </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="ABCDEF"
                                                name="header"
                                                onChange={(e) => handleHeader(e)}
                                                value={header || ""}
                                                pattern="^[A-Z]*$"
                                                maxLength={10}
                                                aria-describedby="inputGroupPrepend"
                                                required={!!header}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {error1 && <div>{error1}</div>}
                                                Please provide a Header.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="5" controlId="validationCustom02" className="mb-4">
                                        <InputGroup hasValidation>
                                            <InputGroup.Text id="inputGroupPrepend">Header ID: </InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="1298347645437812983"
                                                name="headerId"
                                                onChange={(e) => handleHeaderID(e)}
                                                value={headerId || ""}
                                                pattern="^\d{1,19}$"
                                                maxLength={19}
                                                aria-describedby="inputGroupPrepend"
                                                required={!!headerId}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {error2 && <div>{error2}</div>}
                                                Please provide a Header ID.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="2">
                                        <Button type="submit" className="btn add_btn ms-auto">Submit</Button>
                                    </Form.Group>
                                </Row>
                            </Form>
                        </div>

                        <div className="uploaded_items">

                            <DataTable
                                className="custom_tborder"
                                columns={columns}
                                data={filter}

                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                onChangePage={handlePageChange}
                                paginationPerPage={20}
                                paginationRowsPerPageOptions={[20]}
                                onChangeRowsPerPage={handlePerRowsChange}
                                paginationComponentOptions={''} // Pass the custom options here

                                fixedHeader
                                fixedHeaderScrollHeight="420px"
                                selectableRowsHighlight
                                highlightOnHover

                            // subHeader
                            // subHeaderComponent={
                            //   <input type="text" className="w-25 form-control" placeholder='Search Headers' value={search} onChange={(e) => setSearch(e.target.value)} />
                            // }
                            // subHeaderAlign="left"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default HeaderRegist;